import { useReactFlow } from '@xyflow/react';
import { useCallback, useRef } from 'react';

import { getFitViewPadding } from '../utils/getFitViewPadding';

const DEFAULT_ANIMATION_DURATION = 300;

export type ZoomToFitParams = {
  nodeIds?: string[];
  withAnimation?: boolean;
};

export const DEFAULT_ZOOM_TO_FIT_PARAMS: ZoomToFitParams = {
  nodeIds: undefined,
  withAnimation: false,
};

export const useZoomToFit = () => {
  const { fitView, getZoom } = useReactFlow();
  const prefersReducedMotionRef = useRef(
    typeof window !== 'undefined' && window.matchMedia('(prefers-reduced-motion: reduce)').matches,
  );

  const zoomToFit = useCallback(
    (params: ZoomToFitParams = {}) => {
      const mergedParams = { ...DEFAULT_ZOOM_TO_FIT_PARAMS, ...params };

      const { nodeIds, withAnimation } = mergedParams;
      const maxZoom = Math.max(getZoom(), 1);

      requestAnimationFrame(() => {
        fitView({
          duration: withAnimation && !prefersReducedMotionRef.current ? DEFAULT_ANIMATION_DURATION : 0,
          maxZoom,
          nodes: nodeIds ? nodeIds.map((id) => ({ id })) : undefined,
          padding: getFitViewPadding(),
        });
      });
    },
    [fitView, getZoom],
  );

  return { zoomToFit };
};
